import React from "react";
import { Col, Row, Form, Input, Modal, Select, Radio, theme } from "antd";
import { URL_SALE, URL_SKIM, URL_TANK } from "../../constants/urls";
import { PATCH, POST } from "../../frameworks/HttpClient";
import useDropdownItem from "../../common/useDropdownItem";
import { DATE_FORMAT, PRODUCT_TYPE, SKIM_STATUS, TANK_STATUS } from "../../constants/string";
import _ from "lodash";
import ErrorMessages from "../../common/ErrorMessages";
import CustomDatePicker from "../../common/CustomDatePicker";
import { useParams } from "react-router-dom";

export default function ProduceOrderModal(props) {
  const params = useParams();
  const { open, onClose, target, onUpdate, saleOrder } = props;
  const isCreate = target === 'add'
  const [form] = Form.useForm();
  const [newLot, setNewLot] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null)
  const [debouncedLotTank, setDebouncedLotTank] = React.useState('');
  const [debouncedLotSkim, setDebouncedLotSkim] = React.useState('');
  const [debouncedProduct, setDebouncedProduct] = React.useState('');
  const [debouncedBuyer, setDebouncedBuyer] = React.useState('');

  const debounceLotTank = React.useCallback(_.debounce((_searchVal) => { setDebouncedLotTank(_searchVal) }, 800), []);
  const debounceLotSkim = React.useCallback(_.debounce((_searchVal) => { setDebouncedLotSkim(_searchVal) }, 800), []);
  const debounceProduct = React.useCallback(_.debounce((_searchVal) => { setDebouncedProduct(_searchVal) }, 800), []);
  const debounceBuyer = React.useCallback(_.debounce((_searchVal) => { setDebouncedBuyer(_searchVal) }, 800), []);

  const productOptions = useDropdownItem({
    manual: true, 
    url: URL_SALE.SALE_PRODUCT, 
    label_renderer : (e) => e.short_name ? `${e.name} - ${e.short_name}` : `${e.name}`, 
    value: "id", 
    pagination: true, 
    params: { 
      name: debouncedProduct,
      type: params.type === PRODUCT_TYPE.CONCENTRATE_LATEX ? PRODUCT_TYPE.CONCENTRATE_LATEX : PRODUCT_TYPE.SKIM,
      page_size: 999 
    } 
  });

  const buyerOptions = useDropdownItem({
    manual: true, 
    url: URL_SALE.SALE_BUYER, 
    label: "name", 
    value: "id", 
    pagination: true, 
    params: { 
      name : debouncedBuyer,
      page_size: 999 
    } 
  });


  const lotTankOptions = useDropdownItem({ 
    manual: true,
    url: URL_TANK.TANK_TRANSACTION, 
    label: "lot_no", 
    value: "id", 
    pagination: true, 
    params: { page_size: 999, 
      lot_no: debouncedLotTank, 
      has_order_ref : false, 
      product: _.get(saleOrder, 'product', ''),
      state : TANK_STATUS.SELLING },
    label_renderer: (option) => `${option.lot_no} [${option.tank_name}]`
  });
  

  const lotSkimOptions = useDropdownItem({ 
    manual: true,
    url: URL_SKIM.SKIM_PRODUCE_TRANSACTION,
    label: "lot_no", 
    value: "id", 
    pagination: true, 
    params: { page_size: 999, 
      lot_no: debouncedLotSkim, 
      has_order_ref : false, 
      product: _.get(saleOrder, 'product', '') ,
    },
  });

  const {
    token: { colorWarning ,colorSuccess },
  } = theme.useToken();
  
  const handleOK = async () => {
    setLoading(true)
    setErrorMessages(null)
    try {
      const data = await form.validateFields();
      if(data['product'].label){
        data['product'] = data['product'].value
      }
      data["sale_order"] = saleOrder.id
      if(params.type === PRODUCT_TYPE.SKIM){
        if (target?.id) {
          await PATCH(`${URL_SALE.SKIM_PRODUCE_ORDER}${target.id}/`, data);
        } else {
          await POST(URL_SALE.SKIM_PRODUCE_ORDER, data);
        }
      } else {
        if (target?.id) {
          await PATCH(`${URL_SALE.PRODUCE_ORDER}${target.id}/`, data);
        } else {
          await POST(URL_SALE.PRODUCE_ORDER, data);
        }
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setLoading(false)
    }
  };
  
  React.useEffect(() => {
    if(open){
      form.setFieldsValue({ buyer : _.get(saleOrder, 'buyer', ''), product: _.get(saleOrder, 'product', '')})
      lotTankOptions.fetchOptions();
      lotSkimOptions.fetchOptions();
      productOptions.fetchOptions();
      buyerOptions.fetchOptions();
    }
  }, [open]);
  
  React.useEffect(() => {
    if(open){
      lotTankOptions.fetchOptions();
    }
  },[debouncedLotTank])
  
  
  React.useEffect(() => {
    if(open){
      lotSkimOptions.fetchOptions();
    }
  },[debouncedLotSkim])
  
  React.useEffect(() => {
    if(open){
      buyerOptions.fetchOptions();
    }
  },[debouncedBuyer])
  
  
  React.useEffect(() => {
    if(open){
      productOptions.fetchOptions();
    }
  },[debounceProduct])
  
  React.useEffect(() => {
    if (open) {
      setErrorMessages(null)
      if (!isCreate) {
        form.setFieldsValue(target);
        if(!saleOrder && target){
          // productOptions.addOption({name : target.product_name, id: target.product, value :target.product});
        }
        // buyerOptions.addOption({name : target.buyer_name, id: target.buyer, value :target.buyer});
      }
    } else {
      setNewLot(true)
      form.resetFields();
    }
  }, [open]);

  React.useEffect(() => {
    if(saleOrder){
      productOptions.addOption({name : saleOrder.product_name, id: saleOrder.product, value :saleOrder.product});
    }
  },[saleOrder, open])

  return (
    <Modal
      open={open}
      onCancel={onClose}
      okText={isCreate ? "เพิ่ม" : "แก้ไข" }
      cancelText={"ยกเลิก"}
      title={isCreate ? "เพิ่มใบแจ้งผลิต" : "แก้ไขใบแจ้งผลิต"}
      width={700}
      onOk={handleOK}
      destroyOnClose
      okButtonProps={{
        style: { backgroundColor: isCreate ? colorSuccess : colorWarning },
        loading,
      }}
    >
      <ErrorMessages message={errorMessages}/>
      <Form
        form={form}
        style={{ margin: "auto" }}
        layout="vertical"
      >
        <Row gutter={16}>

          <Col span={24}>
            <Form.Item
              label="ลูกค้า"
              name="buyer"
              rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
            >
               <Select
                showSearch
                placeholder="ลูกค้า"
                autoComplete="off"
                disabled={true}
                options={buyerOptions.options}
                filterOption={false}
                style={{ width : '100%'}}
                onSearch={debounceBuyer}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="สินค้าที่ต้องการ"
              name="product"
              rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
            >
              <Select
                showSearch
                placeholder="สินค้าที่ต้องการ"
                autoComplete="off"
                options={productOptions.options}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
                }
                style={{ width : '100%'}}
                onSearch={debounceProduct}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="การกำหนด Lot No."
              name="newLot"
              rules={[{ required: isCreate ? true : false, message: 'กรุณากรอกข้อมูล'}]}
            >
              <Radio.Group 
                disabled={!isCreate}
                onChange={(e) => {
                  setNewLot(e.target.value)
                  form.setFieldValue('tank_transaction', null)
                  form.setFieldValue('lot_no', null)
                }}
                value={newLot}
              >
                <Radio value={true}>สร้าง Lot ใหม่</Radio>
                <Radio value={false}>เลือกจาก Lot ที่ผลิต</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>

          {newLot && <Col span={params.type === PRODUCT_TYPE.SKIM ? 12 : 8}>
            <Form.Item
              label="Lot No."
              name="lot_no"
              rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
            >
                <Input placeholder="Lot No." style={{ width : '100%'}} autoComplete="off"/>
            </Form.Item>
          </Col>}

          {!newLot && params.type === PRODUCT_TYPE.CONCENTRATE_LATEX && <Col span={params.type === PRODUCT_TYPE.SKIM ? 12 : 8}>
          <Form.Item
            label="Lot No."
            name={"tank_transaction"}
            rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
          >
            <Select
              showSearch
              allowClear
              placeholder="Lot No"
              autoComplete="off"
              options={lotTankOptions.options}
              filterOption={false}
              onSearch={debounceLotTank}
              style={{ width : '100%'}}
            />
          </Form.Item>
          </Col>}

          {!newLot && params.type === PRODUCT_TYPE.SKIM && <Col span={params.type === PRODUCT_TYPE.SKIM ? 12 : 8}>
          <Form.Item
            label="Lot No."
            name={"transaction"}
            rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
          >
            <Select
              showSearch
              allowClear
              placeholder="Lot No"
              autoComplete="off"
              options={lotSkimOptions.options}
              filterOption={false}
              onSearch={debounceLotSkim}
              style={{ width : '100%'}}
            />
          </Form.Item>
          </Col>}

          <Col span={params.type === PRODUCT_TYPE.SKIM ? 12 : 8}>
            <CustomDatePicker
              label="วันที่แจ้งผลิต"
              name="due_date"
              rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
              placeholder="เลือกวันที่"
              style={{ width: "100%" }}
              format={DATE_FORMAT}
            />
          </Col>

          <Col span={params.type === PRODUCT_TYPE.SKIM ? 12 : 8}>
          <Form.Item
            label="ปริมาณที่ต้องการ (น้ำหนัก)"
            name="require_weight"
            rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
          >
              <Input placeholder="ปริมาณที่ต้องการ" style={{ width : '100%'}} autoComplete="off"/>
          </Form.Item>
          </Col>

          {params.type === PRODUCT_TYPE.SKIM &&  <Col span={12}>
          <Form.Item
            label="ปริมาณที่ต้องการ (ก้อน)"
            name="require_amount"
            rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
          >
              <Input placeholder="ปริมาณที่ต้องการ" style={{ width : '100%'}} autoComplete="off"/>
          </Form.Item>
          </Col>
          }

          <Col span={12}>
            <Form.Item
              label="Produce By."
              name="produce_by"
            >
                <Input placeholder="ผลิตโดย" style={{ width : '100%'}} autoComplete="off"/>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Sent To."
              name="sent_to"
            >
                <Input placeholder="ส่งถึง" style={{ width : '100%'}} autoComplete="off"/>
            </Form.Item>
          </Col>

          <Col span={24}>
          <Form.Item
            label="หมายเหตุ"
            name="note"
          >
              <Input.TextArea placeholder="หมายเหตุ" style={{ width : '100%'}} autoComplete="off"/>
          </Form.Item>
          </Col>

        </Row>
      </Form>
    </Modal>
  );
}
